import type { AiCostDimension } from '@Application/AiCosts/AiCostDimension';
import type AiCostBreakdownRowView from '@UI/Store/AiCosts/Views/AiCostBreakdownRowView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `list` holds the pages loaded so far (`loadedPage` is the last one, 0-indexed); `dimension`,
 * `accountId` and `queryKey` (period and filters) scope it; `totalRecords` is the server total.
 */
class AiCostBreakdownListView {
	readonly list: readonly AiCostBreakdownRowView[];
	readonly dimension: AiCostDimension;
	readonly accountId: number;
	readonly queryKey: string;
	readonly totalRecords: number;
	readonly loadedPage: number;

	constructor(
		list: readonly AiCostBreakdownRowView[],
		dimension: AiCostDimension,
		accountId: number,
		queryKey: string,
		totalRecords: number,
		loadedPage: number,
	) {
		this.list = list;
		this.dimension = dimension;
		this.accountId = accountId;
		this.queryKey = queryKey;
		this.totalRecords = totalRecords;
		this.loadedPage = loadedPage;

		Object.freeze(this);
	}

	get remainingCount(): number {
		return Math.max(0, this.totalRecords - this.list.length);
	}

	get hasMore(): boolean {
		return this.remainingCount > 0;
	}

	append(rows: readonly AiCostBreakdownRowView[], page: number): AiCostBreakdownListView {
		return new AiCostBreakdownListView(
			[...this.list, ...rows],
			this.dimension,
			this.accountId,
			this.queryKey,
			this.totalRecords,
			page,
		);
	}
}

export default AiCostBreakdownListView;
